// extracted by mini-css-extract-plugin
export default {"button":"Button_button__JBBzO","secButton":"Button_secButton__73tTG"};